import { Modal } from "@mui/material";
import styled from "styled-components";

export const ModalStyled = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
